'use strict';

var ReviewRulesErrorModalDirective = function ReviewRulesErrorModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/review-rules-error-modal.html'),
    link: function link() {}
  };
};
ReviewRulesErrorModalDirective.$inject = [];
module.exports = ReviewRulesErrorModalDirective;